export function setupFilms(doc = document, win = window) {
  if (doc.__sbxFilms) return doc.__sbxFilms;
  const videos = new Map();
  const motion = win.matchMedia?.('(prefers-reduced-motion: reduce)');
  const allowed = () => !doc.hidden && !motion?.matches;
  function sync(video, state) {
    if (!state.visible || !allowed() || state.userPaused) {
      if (!video.paused) video.pause();
      return;
    }
    if (!video.paused || state.pending) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    state.pending = true;
    const attempt = video.play();
    Promise.resolve(attempt).then(() => {
      state.button?.classList.remove('sbx-film__toggle--blocked');
      if (!state.visible || !allowed() || state.userPaused) video.pause();
    }).catch(() => {
      state.button?.classList.add('sbx-film__toggle--blocked');
    }).finally(() => { state.pending = false; });
  }
  const update = () => videos.forEach((state, video) => sync(video, state));
  const observer = win.IntersectionObserver ? new win.IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      sync(entry.target, state);
    });
  }, {threshold: 0}) : null;
  function scan() {
    doc.querySelectorAll('video[data-sbx-film]').forEach(video => {
      if (videos.has(video)) return;
      const rect = video.getBoundingClientRect();
      const state = {visible: rect.bottom > 0 && rect.top < win.innerHeight, userPaused:false, pending:false, button:video.closest('.sbx-film')?.querySelector('.sbx-film__toggle')};
      videos.set(video,state);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      if (state.button) state.button.hidden = false;
      const toggle = () => {
        state.userPaused = !video.paused;
        if (video.paused) {
          state.userPaused = false;
          video.muted = true;
          video.play()?.then(() => state.button?.classList.remove('sbx-film__toggle--blocked')).catch(() => state.button?.classList.add('sbx-film__toggle--blocked'));
        } else video.pause();
      };
      video.addEventListener('click', toggle);
      state.button?.addEventListener('click',toggle);
      video.addEventListener('loadeddata', () => sync(video,state));
      video.addEventListener('canplay', () => sync(video,state));
      video.addEventListener('play', () => {
        if (!state.visible || doc.hidden || state.userPaused) video.pause();
      });
      observer?.observe(video);
      sync(video,state);
    });
  }
  doc.addEventListener('visibilitychange',update);
  win.addEventListener('pageshow',update);
  doc.addEventListener('pointerdown',update,{passive:true});
  motion?.addEventListener?.('change',update);
  doc.addEventListener('shopify:section:load',scan);
  doc.addEventListener('shopify:section:unload',() => {
    videos.forEach((state,video) => {if(!video.isConnected){video.pause();observer?.unobserve(video);videos.delete(video);}});
  });
  scan();
  doc.__sbxFilms = {scan};
  return doc.__sbxFilms;
}
if (typeof document !== 'undefined') setupFilms();
